<template>
  <table class="table table--bordered shadow">
    <tbody>
      <tr>
        <td>Real size</td>
        <td>
          <div class="badge badge--lg">
            <span>{{ realWidth }}</span>
            <span class="mx-1">x</span>
            <span>{{ realHeight }}</span>
          </div>
        </td>
      </tr>

      <tr>
        <td>Display size</td>
        <td>
          <div class="badge badge--lg">
            <span>{{ clientWidth }}</span>
            <span class="mx-1">x</span>
            <span>{{ clientHeight }}</span>
          </div>
        </td>
      </tr>

      <tr>
        <td>Ratio</td>
        <td>1 / {{ ratio }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts">
  defineProps<{
    realWidth: number
    realHeight: number
    clientWidth: number
    clientHeight: number
    ratio: string
  }>()
</script>
